import { Box, Divider, Grid, Typography } from '@mui/material';
import PaperPanelInfo from 'src/components/PaperPanelInfo';
import { FiagroResumeData } from 'src/types/operations/fiagro';

type OperationFIAGROResumeDataProps = {
  data?: Pick<
    FiagroResumeData['data'],
    | 'categoriaCarteiraInvestidaMaisRecente'
    | 'valorAtivoMaisRecente'
    | 'totalPassivoMaisRecente'
  >;
};

export default function OperationFIAGROResumeData({
  data,
}: OperationFIAGROResumeDataProps) {
  return (
    <Box p={1}>
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
          &mdash;Dados
        </Typography>
      </Box>
      <Divider sx={{ height: 2, backgroundColor: 'black' }} />
      <Box py={2}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              first
              title="Categoria de Ativo"
              value={data?.categoriaCarteiraInvestidaMaisRecente ?? 'N/D'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              numeric
              title="Patrimônio Líquido"
              value={data?.valorAtivoMaisRecente ?? 'N/D'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              numeric
              title="Ativo"
              value={data?.valorAtivoMaisRecente ?? 'N/D'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              numeric
              title="Passivo"
              value={data?.totalPassivoMaisRecente ?? 'N/D'}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
